(() => {
  if (!window.matchMedia('(max-width: 767px), (pointer: coarse)').matches) return;

  // This deferred script runs after the app's inline config and before its deferred loader.
  const config = window.FPConfig;
  if (!config || !Array.isArray(config.ignoreKeywords)) return;
  if (!config.ignoreKeywords.includes('/')) config.ignoreKeywords.push('/');
})();
